import React, { useEffect, useState } from "react";
import StyledCoursePage from "./style";
import { Button, Input, message, Modal, Table, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ReactComponent as Edit1 } from "../../../../assets/Icons/edit1.svg";
import { ReactComponent as Delete1 } from "../../../../assets/Icons/delete1.svg";
import EditCourseField from "./EditCourse";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import { ReactComponent as Deleted } from "../../../../assets/Icons/deleted.svg";
import { ReactComponent as Hamburger } from "../../../../assets/Icons/hamburger.svg";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Certificate from "./Certificate";
import FetchData from "../../../../hooks/FetchData";
import { setGetCreateAllCourseMenu } from "../../../../Redux/systemSlice";
import PostUpdateData from "../../../../hooks/postUpdate";
const SortableItem = ({ id, label }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: "grab",
    // padding: "8px",
    margin: "8px 0",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "5px",
    boxShadow: isDragging ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    columnGap: "8px",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <span style={{ cursor: "grab" }}>
        <Hamburger />
      </span>
      <span>{label}</span>
    </div>
  );
};

function Courses() {
  const location = useLocation();
  // Coming back from Adding/Editing Certificate should land on the
  // Certificate tab, not silently reset to Custom Field - the tab is
  // passed via navigate("/settings-course", { state: { activeKey } }).
  const [activeKey, setActiveKey] = useState(location.state?.activeKey || "1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletedModalVisible, setDeletedModalVisible] = useState(false);
  const [reorderModalVisible, setReorderModalVisible] = useState(false);
  const [courseView, setCourseView] = useState("course");
  const [selectedData, setSelectedData] = useState();
  const [savedModalVisible, setSavedModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [courseData, setCourseData] = useState([]);
  console.log("courseData-->", courseData);
  const [searchTerm, setSearchTerm] = useState("");
  const [items1, setItems1] = useState([]);
  const [reorderSaving, setReorderSaving] = useState(false);

  const getCreateAllCourseMenu = useSelector(
    (state) => state.systemTracking.getCreateAllCourseMenu
  );
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const dispatch = useDispatch();

  const handleGetCourseData = async () => {
    if (!userInfo.clientId) return;
    const endpoint = `/settings/getCourseList/${userInfo.clientId}`;
    try {
      const response = await FetchData({ endPoint: endpoint });
      console.log("response--->", response);
      if (response?.statusCode === 200 && response?.response?.length > 0) {
        // The backend already returns these ordered by display_order ASC -
        // .reverse() mutates the array in place and returns that same
        // reference, so it silently reversed courseData (the table's real
        // data source) too, not just the redux copy - same bug as People's
        // Custom Field, just hidden by the mutation.
        dispatch(setGetCreateAllCourseMenu(response.response));
        setCourseData(response.response);
      } else {
        setCourseData([]);
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  console.log("getCreateAllCourseMenu--->", getCreateAllCourseMenu);
  useEffect(() => {
    // See Settings > Account's index.js for why this depends on clientId
    // instead of running once on mount - same hard-refresh race.
    handleGetCourseData();
  }, [userInfo.clientId]);

  const handleDeleteCourseData = async () => {
    const endpoint = `/settings/deletecourse/${userInfo.clientId}/${selectedId}`;
    try {
      // PostUpdateData is axios-backed and throws on any non-2xx response,
      // so this success branch is the only one that ever ran - a 403/404/
      // 409/500 always skipped straight to catch below. That catch used to
      // only console.error, so every delete failure (including the FK
      // conflict returned as 409 - see fk_task_course on the backend)
      // showed the user nothing at all, indistinguishable from Delete
      // silently doing nothing.
      await PostUpdateData({
        endPoint: endpoint,
        method: "DELETE",
      });
      handleGetCourseData();
      handleCancel();
      setDeletedModalVisible(true);
      setTimeout(() => {
        setDeletedModalVisible(false);
      }, 2000);
    } catch (error) {
      handleCancel();
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong while deleting this field"
      );
    }
  };

  const filteredData = courseData.filter((item) =>
    item.course_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onChange = (key) => {
    console.log(key);
    setActiveKey(key);
  };

  // Seed the reorder list from live courseData every time the modal opens,
  // same pattern as the working Settings > People > Custom Field reorder -
  // was previously a hardcoded, unrelated list ("Tutor", "Delivery Type"...)
  // with no connection to the real course fields at all.
  const showReorderModal = () => {
    const mapped = courseData.map((item) => ({
      id: String(item.course_id),
      label: item.course_name,
      course_id: item.course_id,
    }));
    setItems1(mapped);
    setReorderModalVisible(true);
  };

  const handleReorderOk = async () => {
    if (!items1.length) {
      message.error("Nothing to reorder");
      return;
    }

    const payload = items1.map((item, index) => ({
      course_id: item.course_id,
      display_order: index + 1,
    }));

    setReorderSaving(true);
    try {
      const response = await PostUpdateData({
        endPoint: `/settings/reordercourse/${userInfo.clientId}`,
        method: "put",
        obj: payload,
      });

      if (response?.status === 200 || response?.statusCode === 200) {
        setReorderModalVisible(false);
        handleGetCourseData();
        setSavedModalVisible(true);
        setTimeout(() => setSavedModalVisible(false), 2000);
      } else {
        message.error("Error saving order");
      }
    } catch (error) {
      console.error("error", error);
      message.error("Error saving order");
    } finally {
      setReorderSaving(false);
    }
  };

  const handleReorderCancel = () => {
    setReorderModalVisible(false);
  };

  const handleRowClick = (record) => {
    setSelectedData({
      ...record,
      mandatory: record?.mandatory === true ? "yes" : "no",
      visible_on_report: record?.visible_on_report === true ? "yes" : "no",
      visible_to_learn: record?.visible_to_learn === true ? "yes" : "no",
    });
  };

  const showModal = (record) => {
    console.log("record--->", record);
    setIsModalOpen(true);
    setSelectedId(record?.course_id);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const items = [
    {
      key: "1",
      label: (
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: activeKey === "1" ? "#1F243B" : "#636980",
          }}
        >
          Custom Field
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: activeKey === "2" ? "#1F243B" : "#636980",
          }}
        >
          Certificate
        </div>
      ),
    },
  ];
  const columns = [
    {
      title: "Name",
      dataIndex: "course_name",
      key: "course_name",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      // Stored/sent as the Select option's lowercase value ("text",
      // "dropdown", ...) - capitalize only for display here.
      render: (text) =>
        text ? text.charAt(0).toUpperCase() + text.slice(1) : text,
    },
    {
      title: "Mandatory",
      dataIndex: "mandatory",
      key: "mandatory",
      render: (text) => {
        return text === true ? "Yes" : "No";
      },
    },
    {
      title: "Visible on Reports",
      dataIndex: "visible_on_report",
      key: "visible_on_report",
      render: (text) => {
        return text === true ? "Yes" : "No";
      },
    },
    {
      title: "Visible to Learner",
      dataIndex: "visible_to_learn",
      key: "visible_to_learn",
      render: (text) => {
        return text === true ? "Yes" : "No";
      },
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => (
        <div className="action-icons">
          <Edit1
            className="edit-icon"
            onClick={() => {
              handleRowClick(record);
              setCourseView("custom-edit");
            }}
          />
          <Delete1 className="delete-icon" onClick={() => showModal(record)} />
        </div>
      ),
    },
  ];
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 1 },
    })
  );

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setItems1((prev) => {
        const activeIndex = prev.findIndex((i) => i.id === active.id);
        const overIndex = prev.findIndex((i) => i.id === over?.id);
        return arrayMove(prev, activeIndex, overIndex);
      });
    }
  };

  console.log("selectedData---->", selectedData);

  return (
    <>
      <StyledCoursePage>
        {/* {(activeKey === "1" || activeKey === "2") && (
          <div className="first-course">Course</div>
        )} */}
        {courseView === "course" &&
          (activeKey === "1" || activeKey === "2") && (
            <div className="first-course">Course</div>
          )}
        {activeKey === "1" && (
          <>
            {courseView === "course" ? (
              <>
                <Tabs
                  activeKey={activeKey}
                  items={items}
                  onChange={onChange}
                  tabBarStyle={{ width: "202px" }}
                />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <Input
                      placeholder="Search name"
                      prefix={<SearchOutlined style={{ color: "#636980" }} />}
                      className="searchbar-style"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button
                      className="reorder-button"
                      onClick={showReorderModal}
                    >
                      Reorder
                    </Button>
                    <Button
                      className="create-field-button"
                      onClick={() => {
                        setSelectedData("");
                        setCourseView("custom-table");
                      }}
                    >
                      + Create Field
                    </Button>
                  </div>
                </div>
                <br />
                <div>
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? "table-row-white" : "table-row-gray"
                    }
                    className="custom-table"
                  />
                </div>
              </>
            ) : (
              <>
                <EditCourseField
                  setCourseView={setCourseView}
                  selectedData={selectedData}
                  // isEditing={!!selectedData}
                  courseView={courseView}
                  handleGetCourseData={handleGetCourseData}
                />
              </>
            )}
          </>
        )}
        <Modal
          width={631}
          height={481}
          title="Reordering"
          open={reorderModalVisible}
          onOk={handleReorderOk}
          onCancel={handleReorderCancel}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px",
              }}
            >
              <button
                style={{
                  width: "130px",
                  height: "34px",
                  color: "#1F243B",
                  border: "1px solid #1F243B",
                  borderRadius: "8px",
                }}
                onClick={handleReorderCancel}
              >
                Cancel
              </button>
              <button
                style={{
                  width: "130px",
                  height: "34px",
                  backgroundColor: "#C2FAE5",
                  color: "#1F243B",
                  borderRadius: "8px",
                }}
                onClick={handleReorderOk}
              >
                Save Changes
              </button>
            </div>
          }
          style={{ top: "4%" }}
        >
          {/* Add drag-and-drop or other reorder UI components */}
          <DndContext
            sensors={sensors}
            modifiers={[restrictToVerticalAxis]}
            onDragEnd={onDragEnd}
          >
            <SortableContext
              items={items1.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {items1.map((item) => (
                <SortableItem key={item.id} id={item.id} label={item.label} />
              ))}
            </SortableContext>
          </DndContext>
          <br />
          <br />
        </Modal>

        <Modal
          open={savedModalVisible}
          footer={null}
          centered
          closable={false}
          width={180}
          height={100}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            <Tick style={{ width: "34px", height: "34px" }} />
            <p
              style={{
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              Saved
            </p>
          </div>
        </Modal>
        <Modal
          width={440}
          height={177}
          title={
            <div
              style={{
                fontSize: "18px",
                fontWeight: 500,
                textAlign: "left",
              }}
            >
              Delete the File
            </div>
          }
          open={isModalOpen}
          onCancel={handleCancel}
          footer={[
            <div style={{ display: "flex", marginLeft: "100px", gap: "20px" }}>
              <Button
                // className="cancel-button"
                key="cancel"
                onClick={handleCancel}
                style={{
                  width: "130px",
                  height: "34px",
                  padding: "6.5px 38.5px 6.5px 39.5px",
                  borderRadius: "8px",
                  border: "1px solid #1f243b",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                  }}
                >
                  Cancel
                </div>
              </Button>
              <Button
                key="delete"
                onClick={handleDeleteCourseData}
                style={{
                  width: "130px",
                  height: "34px",
                  padding: "6.5px 40.5px 6.5px 41.5px",
                  borderRadius: "8px",
                  border: "1px solid #C2FAE5",
                  backgroundColor: "#C2FAE5",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                  }}
                >
                  Delete
                </div>
              </Button>
            </div>,
          ]}
          centered
          closable={false}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
              textAlign: "left",
              color: "#636980",
            }}
          >
            Are you sure you want to delete this file?
          </p>
          <br />
        </Modal>
        <Modal
          open={deletedModalVisible}
          footer={null}
          centered
          closable={false}
          width={198}
          height={100}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            <Deleted />
            <p
              style={{
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              Deleted
            </p>
          </div>
        </Modal>
        {activeKey === "2" && (
          <>
            <Tabs
              activeKey={activeKey}
              items={items}
              onChange={onChange}
              tabBarStyle={{ width: "202px" }}
            />
            <Certificate />
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Input
                  placeholder="Search"
                  prefix={<SearchOutlined style={{ color: "#636980" }} />}
                  className="searchbar-style"
                />
              </div>
              <div>
                <Button
                  className="create-field-button"
                  // onClick={() => setCourseView("course-create")}
                >
                  + Add Certificate
                </Button>
              </div>
            </div> */}
            <br />
          </>
        )}
      </StyledCoursePage>
    </>
  );
}

export default Courses;
